<template>
    <div>
        <transition name="fade">
            <div v-if="showVideo" class="videopage">
                <div :class="`load-box`">
                    <div class="load-head">Welcome to <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; MOMOverse...</div>
                </div>

                <video v-if="!isMobile" ref="video" class="video-item" width="100%" :autoplay="true" muted>
                    <source src="@/assets/video/door.mp4" type="video/mp4" />
                </video>
                <video v-else ref="videoMobile" class="video-item-1" width="100%" :autoplay="true" muted>
                    <source src="@/assets/video/door1.mp4" type="video/mp4" />
                </video>

                <transition name="fade">
                    <div v-if="showSkipBtn" @click="setSkip" key="0" class="explore-btn">
                        <div class="btn-3">Enter MOMOverse</div>
                        <!-- <img class="clicker" src="@/assets/index/avatargame/clicker.png" /> -->
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
    const $ = window.$;
    export default {
        data(){
            return {
                showVideo : true,
                showSkipBtn : false,
                isMobile : false
            }
        },
        mounted(){
            const $body = $(document.getElementsByTagName('body'));
            $body.addClass('no-scroll');

            const {innerHeight, innerWidth} = window;

            if(innerHeight > innerWidth) {
                this.isMobile = true;
                let t2 = setTimeout(() => {
                    clearTimeout(t2);
                    this.$refs.videoMobile.addEventListener('ended', ()=>{
                        this.showVideo = false;
                        this.sendVideoEnd();
                        this.showSkipBtn = false;
                    });
                }, 100);
            } else {
                this.isMobile = false;
                this.$refs.video.addEventListener('ended', ()=>{
                    this.showVideo = false;
                    this.sendVideoEnd();
                    this.showSkipBtn = false;
                });
            }

            let t = setTimeout(() => {
                this.showSkipBtn = true;
                clearTimeout(t)
            }, 3000);

            let t1 = setTimeout(() => {
                if(this.showVideo){
                    this.showVideo = false;
                    this.sendVideoEnd();
                }
                clearTimeout(t1)
            }, 30000);
        },
        methods:{
            setSkip(){
                this.showVideo = false;
                this.sendVideoEnd();
            },
            sendVideoEnd(){
                $(window).scrollTop(0);

                const $body = $(document.getElementsByTagName('body'));
                $body.removeClass('no-scroll');

                let t = setTimeout(() => {
                    this.$root.eventHub.$emit("amin-end");
                    clearTimeout(t);
                }, 100);

            }
        }
    }
</script>

<style lang="less" scoped>
    .videopage{
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;

        background: black;
        z-index: 5;

        .load-box{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .load-head{
                white-space: nowrap;

                font-size: 130px;
                line-height: 130px;
                background-image: url("../../assets/index/test/test1.png");
                background-clip: text; /* ! */
                color: transparent;    /* ! */

                font-family: Poppins-ex;
                animation: scrollingTxt 5s linear infinite;

                -webkit-text-stroke:1px black;
            }
        }

        .explore-btn{
            position: absolute;
            left: 50%;
            bottom: 50px;
            transform: translate(-50%, 0);

            .clicker{
                position: absolute;
                right: -10%;
                width: 30%;
                top: 30%;

                animation: scaleingB 5s linear infinite;
            }
        }

        .video-item{
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
        }

        .video-item-1{
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 0);
        }
    }
</style>
